import { render, staticRenderFns } from "./app-navigation.vue?vue&type=template&id=e675dd18&scoped=true"
import script from "./app-navigation.vue?vue&type=script&lang=js"
export * from "./app-navigation.vue?vue&type=script&lang=js"
import style0 from "./app-navigation.vue?vue&type=style&index=0&id=e675dd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e675dd18",
  null
  
)

export default component.exports